/**
 * API: Tagalys
 * -----------------------------------------------------------------------------
 * Global Tagalys helper functions.
 * https://tagalys.notion.site/Headless-usage-Tagalys-front-end-JS-components-74bdc2acabc54f27a9eab925916b4299#23749c084e7b4b7e9f3b4a84ff97b8ad
 */

/**
 * Initialise Tagalys SearchSuggestions and store globally.
 * @param {Function} onSuccess - Success callback.
 * @param {Function} onFailure - Failure callback.
 */
export function initTagalysSearchSuggestions(onSuccess, onFailure) {
  window.searchSuggestions = window.Tagalys.APIConnector.SearchSuggestions.new({
    params: {
      request: {
        collections: { limit: 5 },
        // products: { limit: 5 },
        pages: { limit: 5 },
      },
    },
    onSuccess,
    onFailure,
  })
}

/**
 * Perform Tagalys setup and assign callback function.
 * @param {Function} callback - Tagalys API call.
 */
export function onTagalysReady(callback) {
  if (window.Tagalys) {
    initialiseTagalys(callback)
    return
  }

  window.addEventListener('DOMContentLoaded', () => {
    initialiseTagalys(callback)
  })
}

/**
 * Initialise Tagalys based on config and callback function.
 * @param {Function} callback - Tagalys API call.
 */
function initialiseTagalys(callback) {
  setTagalysConfiguration()
  window.Tagalys.Analytics.trackPlatformEvents()
  callback()
}

/**
 * Sets the global Tagalys instance based on theme settings.
 */
function setTagalysConfiguration() {
  const tagalysSettings = cnvs?.credentials?.tagalys

  if (!tagalysSettings || !cnvs?.store) {
    return
  }

  window.Tagalys.setConfiguration({
    api: {
      serverUrl: tagalysSettings.serverUrl,
      credentials: {
        clientCode: tagalysSettings.clientCode,
        apiKey: tagalysSettings.apiKey,
      },
      storeId: tagalysSettings.storeId,
    },
    platform: 'Shopify',
    currency: {
      code: cnvs.store.currency,
      fractionalDigits: '2',
      exchangeRate: 1.00,
    },
    analyticsStorageConsentProvided() {

      /**
       * TODO: Update response to pull from cookie banner response.
       */
      return true
    },
    track: true,
  })

  window.Tagalys.setPlatformConfiguration({
    platform: 'Shopify',
    countryCode: window.Shopify.country,
    baseCountryCode: tagalysSettings.baseCountryCode,
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: tagalysSettings.accessToken,
      myShopifyDomain: window.Shopify.shop,
    },
  })
}
